import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Returns a responsive Tailwind font-size class scaled to a word's length so
 * long words don't overflow their container or get clipped. Kids' word bank
 * mixes short sight words ("run") with long enrichment words ("magnificent"),
 * so a fixed size always breaks for one or the other.
 *
 * - `decode`: the giant single word in the read-aloud / decode game
 * - `match`: the single prompt word in the synonym-match game (choices below)
 * - `tile`: a word tile in a grid (memory / pairs game)
 */
export function wordSizeClass(text: string, variant: 'decode' | 'match' | 'tile') {
  const len = (text ?? '').length
  if (variant === 'tile') {
    if (len <= 5) return 'text-sm sm:text-base'
    if (len <= 8) return 'text-xs sm:text-sm'
    return 'text-[0.7rem] sm:text-xs'
  }
  if (variant === 'decode') {
    if (len <= 6) return 'text-7xl sm:text-8xl'
    if (len <= 9) return 'text-6xl sm:text-7xl'
    if (len <= 12) return 'text-5xl sm:text-6xl'
    return 'text-4xl sm:text-5xl'
  }
  // match
  if (len <= 6) return 'text-6xl sm:text-7xl'
  if (len <= 9) return 'text-5xl sm:text-6xl'
  if (len <= 12) return 'text-4xl sm:text-5xl'
  return 'text-3xl sm:text-4xl'
}
